import React from 'react';
import { Pagination as BsPagination } from 'react-bootstrap';
import Button from 'tradevan-ui/Button';
import ButtonVariantEnum from 'tradevan-ui/Button/enum';
import { PaginationProps } from './type';

/** 第一頁的數字 */
const FRIST_PAGE = 0;
const Pagination = (props: PaginationProps): JSX.Element => {
  const {
    pageSize = 10,
    page = 0,
    count = 0,
    onPageChange,
    pageSizeOptions,
    ...other
  } = props;

  /** 總頁數 */
  const totalPage =
    // 有餘數，就多加一頁(23筆→3頁 20筆→2頁)
    count % pageSize > 0
      ? parseInt(String(count / pageSize), 10) + 1
      : parseInt(String(count / pageSize), 10);

  /** 下一頁 click */
  const handleNextPage = () => {
    const val = page + 1 !== totalPage ? page + 1 : page;
    onPageChange(val, pageSize, count);
  };

  /** 上一頁 click */
  const handlePrevPage = () => {
    // 不再第一頁就給他減一
    const val = page === FRIST_PAGE ? FRIST_PAGE : page - 1;
    onPageChange(val, pageSize, count);
  };

  /** 頁數click */
  // const handleItemClick = (index: number) => {
  //   if (onPageChange) onPageChange(index, pageSize, count);
  // };

  /** 第一頁 click */
  const handleFirstPage = () => {
    onPageChange(FRIST_PAGE, pageSize, count);
  };

  /** 最後一頁 click */
  const handleLastPage = () => {
    onPageChange(totalPage - 1, pageSize, count);
  };

  return (
    <BsPagination
      className="paginator div-tb d-flex justify-content-center"
      {...other}
    >
      {/* 上一頁 */}
      <div className="rl_bt">
        <div className="btn-group">
          <Button
            disabled={count <= 0}
            variant={ButtonVariantEnum.none}
            className="btn btn-sm"
            onClick={handleFirstPage}
          >
            <i className="icon-common_left_2" />
          </Button>
          <Button
            disabled={count <= 0}
            variant={ButtonVariantEnum.none}
            className="btn btn-sm"
            onClick={handlePrevPage}
          >
            <i className="icon-common_left-24px" />
          </Button>
        </div>
      </div>

      {/* 第幾頁~第幾頁 */}
      <div className="ct_bt">
        <span className="d-none d-lg-inline-block">第</span>
        <select
          disabled={count <= 0}
          value={page}
          onChange={(newValue) => {
            onPageChange(Number(newValue.target.value), pageSize, count);
          }}
        >
          {(totalPage > 0 ? new Array(totalPage) : []).fill('').map((v, i) => (
            <option key={v + String(i)} value={i}>
              {i + 1}
            </option>
          ))}
        </select>

        <span className="d-none d-lg-inline-block">/ </span>
        <span className="p-info d-none d-lg-inline-block">{totalPage}</span>
        <span className="d-none d-lg-inline-block">頁，每頁</span>
        {/* pageSizeOption */}
        <select
          disabled={count <= 0}
          className="d-none d-lg-inline-block"
          onChange={(e) => {
            onPageChange(FRIST_PAGE, Number(e.target.value), count);
          }}
        >
          {pageSizeOptions
            .filter((v, i) => i > 0)
            .map((v, i) => (
              <option key={v + String(i)} value={v}>
                {v}
              </option>
            ))}
        </select>
        <span className="d-none d-lg-inline-block"> 筆 ，共{count}筆</span>
      </div>

      <div className="rl_bt">
        <div className="btn-group">
          <Button
            disabled={count <= 0}
            variant={ButtonVariantEnum.none}
            className="btn btn-sm"
            onClick={handleNextPage}
          >
            <i className="icon-common_right-24px" />
          </Button>
          <Button
            disabled={count <= 0}
            variant={ButtonVariantEnum.none}
            className="btn btn-sm"
            onClick={handleLastPage}
          >
            <i className="icon-common_right_2" />
          </Button>
        </div>
      </div>
    </BsPagination>
  );
};

export default Pagination;
